import type { ComponentProps } from 'react';
import { Icon } from 'ui';
import type { WithingsOrderPostTodo } from '../../../../types';
import { BaseTodoWidgetItem } from '../base-todo-widget-item';

type P = {
  className?: string;
  todo: WithingsOrderPostTodo;
  type?: ComponentProps<typeof BaseTodoWidgetItem>['type'];
};

const WithingsOrderPostTodoWidgetItem = ({ className, todo, type }: P) => (
  <BaseTodoWidgetItem
    additionalDescription={todo.withingsOrderPost.textContent}
    className={className}
    description={todo.withingsOrderPost.title}
    icon={<Icon icon="game" />}
    path={todo.path}
    timeConfig={{ options: { display: 'time', mode: 'by' }, time: todo.endTime }}
    title="Order device"
    type={type}
  />
);

export default WithingsOrderPostTodoWidgetItem;
